export const KNOW_MORE_SELF_DELIVERY = "know_more_self_delivery";
